export const manageStatusStyle = ({ chat_value, video_value }) => {
  const PROFESSIONAL_STATUS = [
    { title: 'invisible', status: { chat: 0, video: 0 }, color: 'red' },
    { title: 'activo', status: { chat: 1, video: 0 }, color: 'green' },
    { title: 'ocupado', status: { chat: 2, video: 0 }, color: 'orange' },
    { title: 'video', status: { chat: 0, video: 3 }, color: 'green', icon: 'fas fa-video' },
    { title: 'video', status: { chat: 0, video: 4 }, color: 'green', icon: 'fas fa-video' },
    { title: 'video+chat', status: { chat: 2, video: 3 }, color: 'green', icon: 'fas fa-video' },
    { title: 'video+chat', status: { chat: 2, video: 4 }, color: 'green', icon: 'fas fa-video' },
  ]
  return PROFESSIONAL_STATUS.find((item) => item.status.chat === chat_value && item.status.video === video_value)
}
export const manageVcIconClassName = ({ vcStatus }) => {
  if (vcStatus === 'waiting') return 'fas fa-user-clock'
  if (vcStatus === 'calling/reporting') return 'fas fa-people-arrows'
}
